import { useEffect, useState } from 'react';
import type { PlaceDetails } from '@bilmat/shared';
import { apiGet } from '../lib/apiClient';

type State = { details: PlaceDetails | null; isLoading: boolean; error: string | null };

export function usePlaceDetails(placeId: string | null): State {
  const [state, setState] = useState<State>({ details: null, isLoading: false, error: null });

  useEffect(() => {
    if (!placeId) {
      setState({ details: null, isLoading: false, error: null });
      return;
    }
    const controller = new AbortController();
    setState({ details: null, isLoading: true, error: null });
    void apiGet<{ place: PlaceDetails }>('details', { place_id: placeId }, controller.signal)
      .then((d) => setState({ details: d.place, isLoading: false, error: null }))
      .catch(() => {
        if (controller.signal.aborted) return;
        setState({ details: null, isLoading: false, error: 'Kunde inte hämta detaljer.' });
      });
    return () => controller.abort();
  }, [placeId]);

  return state;
}
